// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import MPBetslipBand from '../components/common/MPBetslipBand';
import MPHistoryBetslipBandSelectors from '../selectors/specifics/MPHistoryBetslipBandSelectors';

type MPHistoryBetslipContainerProps = {
  className?: string;
  betslipId: number;
};

const MPHistoryBetslipContainer = (props: MPHistoryBetslipContainerProps) => {
  const { betslipId, ...ownProps } = props;
  const selectorProps = useMemo(() => ({ betslipId }), [betslipId]);
  const cardName = useSelector((state) => MPHistoryBetslipBandSelectors.selectCardName(state, selectorProps));
  const cardIconImgPath = useSelector((state) =>
    MPHistoryBetslipBandSelectors.selectCardIconImgPath(state, selectorProps),
  );

  const licence = useSelector(selectRuntimeLicence);

  const selectedProps = useMemo(
    () => ({
      cardName,
      cardIconImgPath,
      licence,
    }),
    [cardIconImgPath, cardName, licence],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return cardName && cardIconImgPath ? <MPBetslipBand {...enhancedProps} isDark isCompact /> : null;
};

export default MPHistoryBetslipContainer;
